import { useAemConfig } from '@as-react/common-components';
import { generalQueries } from '@as-react/common-queries';
import { AddressFieldName, HTTPStatusCode } from '@as-react/common-types';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { mapWithAssert } from '../../../../util/ArrayUtil';
import { generateFieldName, isValidPostCode } from '../addressFields.utils';
export const PostcodeWatcher = ({ setAddresses, countryId, prefix }) => {
    const { t } = useTranslation(I18N_NAMESPACES.buy);
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const [postCodeFieldName, cityFieldName] = mapWithAssert([AddressFieldName.POSTCODE, AddressFieldName.CITY], name => generateFieldName(name, prefix));
    const { control, setError, setValue, clearErrors, formState } = useFormContext();
    const [postalCode, city] = useWatch({
        control,
        name: [postCodeFieldName, cityFieldName],
    });
    const { getAddresses } = generalQueries({
        servicesEndpoint,
        defaultRequestParams,
    });
    const { data: addresses, error: addressError } = useQuery(getAddresses({ countryId, postalCode: postalCode }, {
        enabled: Boolean(postalCode) && isValidPostCode(postalCode, countryId),
        retry: false,
    }));
    useEffect(() => {
        var _a;
        if (addressError && ((_a = addressError.response) === null || _a === void 0 ? void 0 : _a.status) !== HTTPStatusCode.InternalServerError) {
            setError(postCodeFieldName, { message: t('buy.error.no.results') });
        }
    }, [addressError]);
    useEffect(() => {
        if (!addresses || addresses.length === 0) {
            return;
        }
        const hasCustomCity = !!city && addresses.every(addressRecord => { var _a; return ((_a = addressRecord.city) === null || _a === void 0 ? void 0 : _a.toUpperCase()) !== city.toUpperCase(); });
        const postcodeIsTouched = Object.keys(formState.touchedFields).includes(postCodeFieldName);
        if (hasCustomCity && !postcodeIsTouched) {
            setAddresses([{ city }, ...addresses]);
            setValue(cityFieldName, city);
            clearErrors(cityFieldName);
            return;
        }
        setAddresses(addresses);
        if (addresses.length === 1 || postcodeIsTouched) {
            const address = addresses[0];
            setValue(cityFieldName, address.city);
            clearErrors(cityFieldName);
        }
    }, [addresses]);
    return null;
};
